module.exports = __webpack_public_path__ + "img/annualForecastBlue.f64c7176.png";